module.exports = __webpack_public_path__ + "img/yhgh8.42e8e5c8.png";